"use client";

import React from "react";

const NightGuardsIntro: React.FC = () => {
  return (
    <div className="w-full py-6 sm:py-8 ">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 text-center pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2 after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]">
          Custom Night Guards: Your Ultimate Protection Against Bruxism & Teeth Grinding
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          Do you often wake up with a sore jaw, headaches, or sensitive teeth? You might be experiencing the effects of bruxism, a condition characterized by chronic teeth grinding and jaw clenching. Don&#39;t let this habit cause long-term damage to your oral health. Discover how custom night guards can safeguard your smile and provide much-needed relief.
        </p>
      </div>
    </div>
  );
};

export default NightGuardsIntro;